import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';

const titleTag = 'h4';
const ctaButtonClass = 'gtm-cta';

export const onDatalayer = ({ componentRef, target }: OnDatalayerProps) => {
  const documentHeadline = componentRef?.current?.querySelector(titleTag)?.innerText || '';
  const isCTA = target?.classList.contains(ctaButtonClass);
  const href = target?.href || '';
  const variantName = (target?.closest('[data-datalayer-variant]') as HTMLDivElement)?.dataset
    ?.datalayerVariant;

  if (!isCTA) {
    return undefined;
  }

  return {
    event: 'clickCTA',
    eventCategory: 'Content List',
    documentHeadline,
    href,
    ...(variantName && { variant_name: variantName }),
  };
};
